import React, { useMemo } from 'react';

import { CheckboxList } from 'modules/shared-ui/components';
import { getDefault, readCMSValue } from 'modules/shared-cms/utils';

import { FilterProps, DressFilterProps } from '../..';

export const DressFilter: React.FC<FilterProps<DressFilterProps>> = ({
    values,
    selectedValue,
    type,
    onSelectChange,
}: FilterProps<DressFilterProps>) => {
    const valueList = useMemo(() => {
        if (!values || values.length === 0) {
            return [];
        }

        return values
            .map(v => {
                const value = getDefault(readCMSValue(v.data.value), '');
                const label = getDefault(readCMSValue(v.data.text), '');
                return {
                    value,
                    label,
                    isSelected:
                        selectedValue && Array.isArray(selectedValue)
                            ? selectedValue.findIndex(sv => sv.toUpperCase() === value.toUpperCase()) > -1
                            : false,
                };
            })
            .sort((n1, n2) => {
                if (n1.label > n2.label) {
                    return 1;
                }

                if (n1.label < n2.label) {
                    return -1;
                }

                return 0;
            });
    }, [values, selectedValue]);
    return <CheckboxList<string> values={valueList} onSelectionChange={newValues => onSelectChange(newValues, type)} />;
};
